import React from 'react';
import PropTypes from 'prop-types';
import searchIcon from 'assets/search.svg';
import styles from './searchBar.module.scss';

const SearchBar = ({ placeholder, query, name, setQuery, height }) => {
  const searchItems = (searchValue) => {
    setQuery(searchValue);
  };

  return (
    <div className={`${styles.search} ${height && styles[height]}`}>
      <img src={searchIcon} alt="search icon" className={styles.icon} />
      <input
        className={styles.input}
        type="search"
        placeholder={placeholder}
        name={name}
        value={query}
        onChange={(e) => searchItems(e.target.value)}
      />
    </div>
  );
};

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  setQuery: PropTypes.func,
  query: PropTypes.string,
  name: PropTypes.string,
  height: PropTypes.string,
};

export default SearchBar;
